import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { GameProvider, useGame } from './contexts/GameContext';
import { ChatProvider } from './contexts/ChatContext';
import Login from './pages/Login';
import CreateCharacter from './pages/CreateCharacter';
import GameScreen from './pages/GameScreen';
import LoadingOverlay from './components/LoadingOverlay/LoadingOverlay';
import NotificationSystem from './components/NotificationSystem/NotificationSystem';
import './App.css';

// Компонент для управления роутингом на основе состояния игры
function AppRoutes() {
  const { state } = useGame();
  const { isLoading, isAuthenticated, character, characterLoading, socketConnected, connectionStatus } = state;

  // Показываем загрузку при инициализации
  if (isLoading) {
    return <LoadingOverlay isVisible={true} status={connectionStatus} />;
  }

  return (
    <Routes>
      <Route path="/login" element={!isAuthenticated ? <Login /> : <Navigate to="/" />} />
      <Route path="/create-character" element={
        isAuthenticated && !character && !characterLoading && socketConnected ? 
          <CreateCharacter /> : 
          <Navigate to="/" />
      } />
      <Route path="/game" element={
        isAuthenticated && character ? <GameScreen /> : <Navigate to="/" />
      } />
      <Route path="/" element={
        isAuthenticated ? (
          character ? (
            <Navigate to="/game" />
          ) : (
            socketConnected && !characterLoading ? 
              <Navigate to="/create-character" /> : 
              (
                <div className="app-container">
                  <p>{characterLoading ? 'Загрузка персонажа...' : 'Подключение к игровому серверу...'}</p>
                  <div className="loading-spinner"></div>
                </div>
              )
          )
        ) : (
          <Navigate to="/login" />
        )
      } />
    </Routes>
  );
}

function App() {
  return (
    <GameProvider>
      <ChatProvider>
        <Router>
          <AppRoutes />
          <NotificationSystem />
        </Router>
      </ChatProvider>
    </GameProvider>
  );
}

export default App;
